import del from './methodDelete';
import get from './methodGet';
import post from './methodPost';
import patch from './methodPatch';

export default { ...del, ...get, ...post, ...patch };
